
<div class="page-content">
  <div class="row">
    <div class="col-md-12">

      <div class="table-responsive">
        <table class="table table-sortable" *ngIf="templates">
          <thead style="-webkit-text-fill-color: #606060;">
            <tr>
              <th class="col-md-4 text-start">
                <a href="#" (click)="sortColumn($event,'name');" style="text-decoration: none; color: #606060;">
                  Template Name
                  <span class="th-sort">
                    <span *ngIf="queryContainer.query.sortByColumn === 'name'">
                      <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                      <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                    </span>
                  </span>
                </a>
              </th>
              <th class="col-md-2 text-start">
                <a href="#" (click)="sortColumn($event,'createdDate');preventDefault;" style="text-decoration: none; color: #606060;">
                  Created on
                  <span class="th-sort">
                    <span *ngIf="queryContainer.query.sortByColumn=== 'createdDate'">
                      <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                      <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                    </span>
                  </span>
                </a>
              </th>
              <th class="col-md-2 text-start">
                <a href="#" (click)="sortColumn($event,'updateDate');" style="text-decoration: none; color: #606060;">
                  Edited on
                  <span class="th-sort">
                    <span *ngIf="queryContainer.query.sortByColumn == 'updateDate'">
                      <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                      <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                    </span>
                  </span>
                </a>
              </th>
              <th class="col-md-2 text-start">
                <a href="#" (click)="sortColumn($event,'createdByName');" style="text-decoration: none; color: #606060;">
                  Author
                  <span class="th-sort">
                    <span *ngIf="queryContainer.query.sortByColumn == 'createdByName'">
                      <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                      <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                    </span>
                  </span>
                </a>
              </th>
              <th class="col-md-2" style="text-align:justify;">
                <a href="#" (click)="sortColumn($event,'noOfTimecards');" style="text-decoration: none; color: #606060;">
                  # of Timecards
                  <span class="th-sort">
                    <span *ngIf="queryContainer.query.sortByColumn == 'noOfTimecards'">
                      <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                      <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                    </span>
                  </span>
                </a>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let template of templates">             
              <td class="text-start"><a class="btn-link" href="/scorepay/bu/{{template.businessUnit.id}}/templates/list/{{template.id}}/details">{{template.name}}</a></td>
              <td class="text-start">{{template.audit.createdDate | date}}</td>
              <td class="text-start">{{template.audit.updateDate | date}}</td>
              <td class="text-start">{{template.audit.createdByName}}</td>
              <td style="text-align:justify;">{{template.noOfTimecards}}</td>
              <td class="text-end">
                <button type="button" class="btn btn-icon-clear" title="Clone Template" (click)="openCloneTemplateModal(template)" authenticate-user="position.create"><i class="fa fa-copy"></i></button>
              </td>
            </tr>
            <tr *ngIf="!templates || templates.length==0">
              <td colspan="8">No results</td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>
  </div>
</div>
